import { render, staticRenderFns } from "./OrderKanbanItem.vue?vue&type=template&id=24156602&scoped=true&"
import script from "./OrderKanbanItem.vue?vue&type=script&lang=js&"
export * from "./OrderKanbanItem.vue?vue&type=script&lang=js&"
import style0 from "~/components/orderKanban/OrderKanbanItem.scss?vue&type=style&index=0&id=24156602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24156602",
  null
  
)

export default component.exports